import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { formatDate, DatePipe } from '@angular/common';
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { DetailsPerson } from './Search';
import { url } from './../../shared/urls/url';



@Injectable({
  providedIn: 'root'
})
export class SearchService {
  // URLString = 'http://localhost:50810';
  constructor(private http: HttpClient, private URLString: url, private datepipe: DatePipe) { }
  httpOptions = {
    headers: new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('TokenServe'), responseType: 'arraybuffer', })
  };

  searchIdNumber(IdNumber) {

    localStorage.setItem('DataSearch', JSON.stringify(IdNumber));
    const urlSt = this.URLString.apibackdavid + '/api/Search/SearchTypeId';
    return this.http.post(urlSt, IdNumber, this.httpOptions).pipe(
      catchError(this.handleError<any[]>('getEntity', []))
    );
  }

  searchEntity(entity): Observable<any> {
    const urlSt = this.URLString.apibackdavid + '/api/Search/SearchEntity';
    console.log(entity.SearchPercentage);
    const data = {
      entityName: entity.Entity,
      hitsFrom: 11,
      hitsTo: 15,
      searchType: (typeof entity.DefineSearchType === 'undefined') ? '0' : entity.DefineSearchType,
      filterRegion: entity.filterRegion,
      filterPep: entity.CategoryPep,
      filterSic: entity.SpecialCategory,
      porcentaje: entity.SearchPercentage,
      DateLocal: this.datepipe.transform(Date.now(), 'MM-dd-yyyy')
    };

    localStorage.setItem('DataSearch', JSON.stringify(data));
    console.log(localStorage.getItem('DataSearch'));

    return this.http.post(urlSt, data).pipe(
      catchError(this.handleError<any[]>('getEntity', []))
    );
  }

  searchPerson(search): Observable<any> {

    const urlSt = this.URLString.apibackdavid + '/api/Search/SearchPerson';
    const CDate = new Date(search.Birthdate);
    const CYear = new Date(search.Year);

    const year = (typeof search.Year === 'undefined') ? '' : CYear.getFullYear() + '-' + CYear.getFullYear();

    const data = {
      firstName: search.FirstName,
      hitsFrom: 0,
      hitsTo: 100,
      middleName: search.SecondName,
      searchType: (typeof search.DefineSearchType === 'undefined') ? '0' : search.DefineSearchType,
      surname: search.Surname,
      filterRegion: search.filterRegion,
      filterPep: search.CategoryPep,
      filterSic: search.SpecialCategory,
      dateOfBirth: (((typeof search.Birthdate === 'undefined') || (search.Birthdate === ''))
        && ((typeof search.Year === 'undefined') || (search.Year === ''))) ? ''
        : (typeof search.Birthdate !== 'undefined') ? formatDate(CDate, 'yyyy-MM-dd', 'en-US').toString()
          : (typeof search.Year !== 'undefined') ? year : '',
      porcentaje: search.SearchPercentage,
      DateLocal: this.datepipe.transform(Date.now(), 'MM-dd-yyyy')
    };

    localStorage.setItem('DataSearch', JSON.stringify(data));
    console.log(localStorage.getItem('DataSearch'));

    return this.http.post(urlSt, data, this.httpOptions).pipe(
      catchError(this.handleError<any[]>('getPerson', []))
    );
  }

  DetailPersonEntity(idPersonEntity) {
    const urlSt = this.URLString.apibackdavid + '/api/SearchDetail/DetailPE/' + idPersonEntity;

    return this.http.get(urlSt, this.httpOptions).pipe(
      catchError(this.handleError<any>('getPersonID', []))
    );

  }

  ShowPDF(Pid) {
    const urlSt = this.URLString.apibackdavid + '/api/SearchDetail/DetailPDF';
    const httpOptionsPDF = {
      headers: new HttpHeaders({
        responseType: 'arraybuffer',
        'Authorization': 'Bearer ' + localStorage.getItem('TokenServe')
      })
    };

    const data = {
      DataSearch: localStorage.getItem('DataSearch'),
      ID: Pid
    };

    return this.http.post(urlSt, data, { responseType: 'arraybuffer' });
  }

  SendEmail(Pid, email) {
    const urlSt = this.URLString.apibackdavid + '/api/SearchDetail/DetailEmail';
    const data = {
      email: email,
      id: Pid,
      DataSearch: localStorage.getItem('DataSearch'),
    };

    return this.http.post(urlSt, data, this.httpOptions).pipe(
      catchError(this.handleError<any>('getDetailEmail', []))
    );
  }

  Verifications(idCuenta) {
    const httpOptionsVerif = {
      headers: new HttpHeaders({
        responseType: 'text',
        'Authorization': 'Bearer ' + localStorage.getItem('TokenServe')
      })
    };
    const url6 = this.URLString.apiback + '/VerificacionesRestantes?=' + idCuenta;
    return this.http.get(url6, httpOptionsVerif);
  }

  GetAccount(guid) {
    return this.http.get(this.URLString.apiback + '/getaccount?id=' + guid, this.httpOptions);
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.error(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
